import {
    IContactsResponse,
    IContactState,
    IContactUsContent,
    initialContactsResponse,
    initialContactUsContent
} from "./Helper";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import {deleteContact, getContacts, getContactUsContent} from "./ActionCreators";

const initialValue: IContactState = {
    fetchContactsLoading: false,
    items: initialContactsResponse,
    deleteContactLoading: false,
    content: initialContactUsContent,
    contentLoading: true
}

const contactSlice = createSlice({
    name: SliceNames.CONTACT,
    initialState: initialValue,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(
            getContacts.pending, (state) => {
                state.fetchContactsLoading = true
            })
            .addCase(
                getContacts.fulfilled, (state, action: PayloadAction<IContactsResponse>) => {
                    state.items = action.payload
                    state.fetchContactsLoading = false
                })
            .addCase(
                getContacts.rejected, (state) => {
                    state.items = initialContactsResponse
                    state.fetchContactsLoading = false
                })
            .addCase(
                deleteContact.pending, (state) => {
                    state.deleteContactLoading = true
                })
            .addCase(
                deleteContact.fulfilled, (state, action: PayloadAction<any>) => {
                    state.items = {
                        count: state.items.count - 1,
                        total_pages: state.items.total_pages,
                        data: [...state.items.data].filter(c => c.id !== action.payload)
                    }
                    state.deleteContactLoading = false
                })
            .addCase(
                deleteContact.rejected, (state) => {
                    state.deleteContactLoading = false
                })
            .addCase(getContactUsContent.pending, (state) => {
                state.contentLoading = true
            })
            .addCase(
                getContactUsContent.fulfilled, (state, action: PayloadAction<IContactUsContent>) => {
                    state.content = action.payload
                    state.contentLoading = false
                })
            .addCase(
                getContactUsContent.rejected, (state) => {
                    state.contentLoading = false
                })

    }
})

export default contactSlice.reducer
